import { useEffect, useState } from 'react';

import {
    Box,
    useBreakpointValue
} from '@chakra-ui/react';

import { Calendar, momentLocalizer} from 'react-big-calendar';

import moment from 'moment';
import 'moment-timezone';

import "react-big-calendar/lib/css/react-big-calendar.css";
import "./Calendar/CustomCalendarStyles.css";

import { CustomToolbar } from './Calendar/CustomToolbar';
import { CustomEvent } from './Calendar/CustomEvent';
import { EventDaysView } from './Calendar/EventDaysView';

import { differenceInHours, addHours } from "date-fns"
import { toZonedTime } from "date-fns-tz"

export function SetCalendar({eventConfig, calSchedule, setups}) {
  moment.tz.setDefault("America/Caracas");
  const localizer = momentLocalizer(moment);

  const [backgroundEvents, setBackgroundEvents] = useState([]);
  const [events, setEvents] = useState([]);

    const isMobile = useBreakpointValue(
        {
          "base": ()=> true,
          "xl": ()=>  false
        }
    );  

  const liveLong = eventConfig["liveLong"];
  const eventDates = eventConfig["eventDates"];
  const startDate = eventConfig["startDate"];

  useEffect(()=>{
    const newBackgroundEvents = [];

    const title = {
      setupId: "",
      setupName: "",
      memberName: false,
      nonSetEventName: liveLong, //pass for events that aren't sets
    };

    eventDates.forEach((eventDate, idx)=>{
      const adjTitle = {
        ...title,
        slotStart: moment(eventDate?.["date"] + " " + eventDate?.["start"]).format('h:mm A'),
        slotEnd: moment(eventDate?.["date"] + " " + eventDate?.["end"]).format('h:mm A'),
        showFreePlay: true
      }

      const adjTitleBoardGames = {
        ...title,
        isSideEvent: true,
        nonSetEventName: "Board Games",
        slotStart: moment(eventDate?.["date"] + " " + "12:00:00").format('h:mm A'),
        slotEnd: moment(eventDate?.["date"] + " " + eventDate?.["end"]).format('h:mm A'),
      }        

      //ANY SIDE EVENTS THAT HAPPEN THE WHOLE TIME ALSO GO HERE
      newBackgroundEvents.push(
        {
          id: idx,
          title: adjTitle,
          allDay: false,
          start: new Date(eventDate?.["date"] + " " + eventDate?.["start"]),
          end: new Date(eventDate?.["date"] + " " + eventDate?.["end"])
        },
        {
          id: idx,
          title: adjTitleBoardGames,
          allDay: false,
          start: new Date(eventDate?.["date"] + " " + "12:00:00"),
          end: new Date(eventDate?.["date"] + " " + eventDate?.["end"])
        },
      )
    });

    setBackgroundEvents([...newBackgroundEvents]);
  }, [eventDates]);

  useEffect(()=>{
    //PUT SIDE EVENTS ETC HERE
    const newEvents = [
        {
          id: "side1",
          title: {
            nonSetEventName: "Halloween Costume Contest",
            isSideEvent: true,
            slotStart: moment("2025-10-31 23:00:00").format('h:mm A'),
            slotEnd: moment("2025-10-31 23:59:59").format('h:mm A'),          
          },
          allDay: false,
          start: new Date("2025-10-31 23:00:00"),
          end: new Date("2025-10-31 23:59:59")
        },      
        {
          id: "side2",
          title: {
            nonSetEventName: "Group Picture",
            isSideEvent: true,
            slotStart: moment("2025-11-01 14:00:00").format('h:mm A'),
            slotEnd: moment("2025-11-01 14:15:00").format('h:mm A'),          
          },
          allDay: false,
          start: new Date("2025-11-01 14:00:00"),
          end: new Date("2025-11-01 17:02:00")
        },          
        {
          id: "side3",
          title: {
            nonSetEventName: "Stamina Radio LIVE Rave",
            isSideEvent: true,
            slotStart: moment("2025-11-01 23:00:00").format('h:mm A'),
            slotEnd: moment("2025-11-01 23:59:59").format('h:mm A'),          
          },
          allDay: false,
          start: new Date("2025-11-01 23:00:00"),
          end: new Date("2025-11-01 23:59:59")
        },      
        {
          id: "side4",
          title: {
            nonSetEventName: "Pumpkin Hunt Results",
            isSideEvent: true,
            slotStart: moment("2025-11-02 15:00:00").format('h:mm A'),
            slotEnd: moment("2025-11-02 15:15:00").format('h:mm A'),          
          },
          allDay: false,
          start: new Date("2025-11-02 15:00:00"),
          end: new Date("2025-11-02 18:02:00")
        },                          
    ];

    Object.values(calSchedule).forEach((scheduleSlot, idx)=>{

      const memberName = scheduleSlot?.["members_name"]
        ? `${scheduleSlot["members_name"]}`
        : false;

      const memberProfileImg = scheduleSlot?.["members_profile_img"] && scheduleSlot["members_profile_img"].length > 0
        ? `${scheduleSlot["members_profile_img"]}`
        : false;

      const title = {
        setupId: scheduleSlot?.["schedule_setup_id"],
        setupName: setups[scheduleSlot?.["schedule_setup_id"]]["setup_name"],
        memberName: memberName,
        memberProfileImg: memberProfileImg,
        slotStart: moment(scheduleSlot["schedule_time_start"]).format('h:mm A'),
        slotEnd: moment(scheduleSlot["schedule_time_end"]).format('h:mm A'),
      };

      newEvents.push(
        {
          id: idx,
          title: title,
          allDay: false,
          start: new Date(scheduleSlot["schedule_time_start"]),
          end: new Date(scheduleSlot["schedule_time_end"])
        },
      )
    });

    setEvents([...newEvents]);
  }, [calSchedule, isMobile()]);

  /**
   * Maps an array of custom event objects to react-big-calendar Event objects,
   * adjusting dates for the specified time zone.
   *
   * @template T - The type of the input event objects, which must include `start`, `end`, and `timeZone`.
   * @param {T[]} events - An array of event objects.
   * @returns {import("react-big-calendar").Event[]} An array of react-big-calendar compatible event objects.
   */
  const mapEvents = (events) =>
      events.map(event => {
          const [start, end] = getDatesWithOffset(
              event.start,
              event.end,
              "America/Caracas"
          );

          return {
              ...event,
              start,
              end,
          };
      });

  /**
   * Adjusts start and end dates based on a specified time zone offset.
   *
   * @param {Date | number} startTime - The original start time.
   * @param {Date | number} endTime - The original end time.
   * @param {string} timeZone - The IANA time zone name (e.g., "America/New_York").
   * @returns {[Date, Date]} A tuple containing the new start and end dates with the offset applied.
   */
  const getDatesWithOffset = (startTime, endTime, timeZone) => {
      // Get the time zoned start time in UTC
      const zonedStart = toZonedTime(startTime, timeZone);

      // Calculate the offset (moving in opposite direction of the delta)
      const offset = differenceInHours(zonedStart, startTime) * -1;

      // Adjust start and end times by the calculated offset
      const startWithOffset = addHours(startTime, offset);
      const endWithOffset = addHours(endTime, offset);

      return [startWithOffset, endWithOffset];
  };

  try {
      return (
        <Box 
          bgColor="#e9eaeb"
          color="#1a202c"
          borderRadius="5px"
        >
          <Calendar
            backgroundEvents={mapEvents(backgroundEvents)}
            localizer={localizer}
            events={mapEvents(events)}
            startAccessor="start"
            endAccessor="end"
            defaultDate={startDate}
            style={{ height: 750 }}
            views={{ weekdays: EventDaysView, day: true /* uncomment if you want more views -->, month: true, week: true,  */ }}
            messages={{ weekdays: "All Days" }}
            defaultView={"day"}
            min={startDate} // this and 'max' set bounds for the hours
            tooltipAccessor=""
            components={{
              event: CustomEvent,
              toolbar: CustomToolbar(startDate), //if you want next/back/today back, get rid of this
              header: () => null //supposedly nukes the header but I don't trust it so we're gonna remove in css also
            }}
          />
        </Box>
      );
  } catch (e) {
      console.error("Calendar render error: ", e);
  }
}